export const V1_REQUEST_COMPLETED = 'V1_REQUEST_COMPLETED'

export default data => ({
  type: V1_REQUEST_COMPLETED,
  data,
})
